import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Ship, TrendingUp, Settings, Zap, Leaf, BarChart3, Users, Crown } from 'lucide-react';

const iconMap = {
  Ship,
  TrendingUp, 
  Settings,
  Zap,
  Leaf,
  BarChart3,
  Users,
  Crown
};

const Services = ({ services }) => {
  if (!services || services.length === 0) {
    return (
      <section id="services" className="dark-container py-20">
        <div className="dark-content-container text-center">
          <div className="text-white">Loading services...</div>
        </div>
      </section>
    );
  }

  return (
    <section id="services" className="dark-container py-20">
      <div className="dark-content-container">
        <div className="text-center mb-16">
          <h2 className="display-large text-white mb-6">
            Choose The Services You Want
          </h2>
          <p className="body-large text-text-secondary max-w-3xl mx-auto">
            Comprehensive maritime solutions for vessel optimization, digital transformation, and sustainable operations.
          </p>
        </div>
        
        <div className="dark-grid">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card key={service.id} className="bg-bg-secondary border-border-subtle hover:border-brand-primary/50 transition-all duration-400 dark-hover">
                <CardHeader>
                  <div className="w-12 h-12 bg-brand-hover rounded-lg flex items-center justify-center mb-4">
                    <Icon className="text-brand-primary" size={24} />
                  </div>
                  <CardTitle className="heading-3 text-white">{service.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="body-medium text-text-secondary mb-6">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-center gap-2 body-small text-text-muted">
                        <div className="w-1 h-1 bg-brand-primary rounded-full"></div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;